export default {
    confirmLabel: '确定'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/input-item/locale/zh_CN.js
// module id = 352
// module chunks = 0